import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=eadb3ae8&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
import style0 from "./Settings.vue?vue&type=style&index=0&id=eadb3ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadb3ae8",
  null
  
)

export default component.exports